import { useState, useEffect } from 'react';

interface ResponsiveLayout {
  isMobile: boolean;
  isTabletVertical: boolean;
  shouldUseScrollLayout: boolean;
}

export const useResponsiveLayout = (): ResponsiveLayout => {
  const [layout, setLayout] = useState<ResponsiveLayout>({
    isMobile: false,
    isTabletVertical: false,
    shouldUseScrollLayout: false,
  });

  useEffect(() => {
    const checkLayout = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const isMobile = width <= 768;
      const isTabletVertical = width <= 1024 && height > width; // Tablet in portrait mode
      const shouldUseScrollLayout = isMobile || isTabletVertical;

      setLayout({
        isMobile,
        isTabletVertical,
        shouldUseScrollLayout,
      });
    };

    // Check on mount
    checkLayout();

    // Add event listener for window resize
    window.addEventListener('resize', checkLayout);

    // Cleanup
    return () => window.removeEventListener('resize', checkLayout);
  }, []);

  return layout;
};
